<template>
  <transition name="modal" v-if="videoView != null">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="row t-a-center" style="max-height: 90vh;">
            <h3 class="title text-white t-a-center">
            {{ videoView.Title }}
            </h3>
            <video v-if="videoView.Media != null"
              preload="metadata"
              class="frame-video" 
              controls
              :title="'Video - ' + videoView.Media.url" >
              <source
                :src="baseUrl + videoView.Media.url"
                :type="videoView.Media.mime"
              />
            </video>

            <iframe class="iframe-youtube" v-if="videoView.Media == null && videoView.LinkYoutubeVideo != null && videoView.LinkYoutubeVideo != ''" :src="videoView.LinkYoutubeVideo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                       
            <iframe class="vimeoIFrame" v-if="videoView.Media == null && videoView.IDVimeoVideo != null && videoView.IDVimeoVideo != ''" :src="'https://player.vimeo.com/video/' + videoView.IDVimeoVideo + '?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" title=""></iframe>

            <a v-on:click.stop.prevent="closeModal()" class="btn btn-dark btn-theme-colored btn-sm">CHIUDI</a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>

.vimeoIFrame {
  width: 100%;
  max-height: 75vh;
  height: auto;
  aspect-ratio: 16 / 9;
}

.iframe-youtube{
  width: 100%;
  max-height: 75vh;
  height: auto;
  aspect-ratio: 16 / 9;
}


.frame-video{
  width: 100%;
  max-height: 75vh;
  height: auto;
}


.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: table;
  transition: opacity 0.7s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>

<script>
export default {
  name: "VideoModal",
  props: ["videoView"],
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_URL,
    };
  },
  methods:{
    closeModal(){
        this.$emit("closeModal");
    }
  },
};
</script>
